import "./src/styles/global.scss";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/instrument-sans/500.css";
import "@fontsource/instrument-sans/400.css";

export const onRouteUpdate = (x) => {
  document.body.classList.remove("overflow-hidden");
};
